import { CANONICAL_ITEM_KINDS } from './contracts';

const normalizeCategoryKey = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[\s_-]+/g, '');

const CRAFT_CATEGORY_ALIASES = Object.freeze({
  weapon: {
    canonicalKind: CANONICAL_ITEM_KINDS.weapon,
    legacyInventoryCategory: 'combat',
    craftCategory: 'weapons',
  },
  weapons: {
    canonicalKind: CANONICAL_ITEM_KINDS.weapon,
    legacyInventoryCategory: 'combat',
    craftCategory: 'weapons',
  },
  armor: {
    canonicalKind: CANONICAL_ITEM_KINDS.armor,
    legacyInventoryCategory: 'combat',
    craftCategory: 'armor',
  },
  armors: {
    canonicalKind: CANONICAL_ITEM_KINDS.armor,
    legacyInventoryCategory: 'combat',
    craftCategory: 'armor',
  },
  potion: {
    canonicalKind: CANONICAL_ITEM_KINDS.consumable,
    legacyInventoryCategory: 'consumable',
    craftCategory: 'potions',
  },
  potions: {
    canonicalKind: CANONICAL_ITEM_KINDS.consumable,
    legacyInventoryCategory: 'consumable',
    craftCategory: 'potions',
  },
  food: {
    canonicalKind: CANONICAL_ITEM_KINDS.consumable,
    legacyInventoryCategory: 'consumable',
    craftCategory: 'food',
  },
  foods: {
    canonicalKind: CANONICAL_ITEM_KINDS.consumable,
    legacyInventoryCategory: 'consumable',
    craftCategory: 'food',
  },
  scroll: {
    canonicalKind: CANONICAL_ITEM_KINDS.consumable,
    legacyInventoryCategory: 'consumable',
    craftCategory: 'potions',
  },
  scrolls: {
    canonicalKind: CANONICAL_ITEM_KINDS.consumable,
    legacyInventoryCategory: 'consumable',
    craftCategory: 'potions',
  },
  material: {
    canonicalKind: CANONICAL_ITEM_KINDS.component,
    legacyInventoryCategory: 'component',
    craftCategory: 'materials',
  },
  materials: {
    canonicalKind: CANONICAL_ITEM_KINDS.component,
    legacyInventoryCategory: 'component',
    craftCategory: 'materials',
  },
  ingredient: {
    canonicalKind: CANONICAL_ITEM_KINDS.component,
    legacyInventoryCategory: 'component',
    craftCategory: 'materials',
  },
  ingredients: {
    canonicalKind: CANONICAL_ITEM_KINDS.component,
    legacyInventoryCategory: 'component',
    craftCategory: 'materials',
  },
  component: {
    canonicalKind: CANONICAL_ITEM_KINDS.component,
    legacyInventoryCategory: 'component',
    craftCategory: 'materials',
  },
  components: {
    canonicalKind: CANONICAL_ITEM_KINDS.component,
    legacyInventoryCategory: 'component',
    craftCategory: 'materials',
  },
  tool: {
    canonicalKind: CANONICAL_ITEM_KINDS.gear,
    legacyInventoryCategory: 'misc',
    craftCategory: 'tools',
  },
  tools: {
    canonicalKind: CANONICAL_ITEM_KINDS.gear,
    legacyInventoryCategory: 'misc',
    craftCategory: 'tools',
  },
  gear: {
    canonicalKind: CANONICAL_ITEM_KINDS.gear,
    legacyInventoryCategory: 'misc',
    craftCategory: 'tools',
  },
});

const LEGACY_INVENTORY_CATEGORY_TO_CRAFT_CATEGORY = Object.freeze({
  weapon: 'weapons',
  armor: 'armor',
  combat: 'weapons',
  consumable: 'potions',
  component: 'materials',
  storage: 'materials',
  quest: 'tools',
  misc: 'materials',
});

const getCraftCategoryAlias = (category) => (
  CRAFT_CATEGORY_ALIASES[normalizeCategoryKey(category)] || null
);

export const mapCraftCategoryToCanonicalKindAlias = (category) => (
  getCraftCategoryAlias(category)?.canonicalKind || null
);

export const mapCraftCategoryToLegacyInventoryCategory = (category) => (
  getCraftCategoryAlias(category)?.legacyInventoryCategory || null
);

export const mapLegacyInventoryCategoryToCraftCategory = (category) => (
  LEGACY_INVENTORY_CATEGORY_TO_CRAFT_CATEGORY[normalizeCategoryKey(category)] || null
);
